<div
  class="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-2 pointer-events-none"
  aria-live="polite"
  aria-atomic="false"
>
  @for (toast of notificationSvc.toasts(); track toast.id) {
    <div
      class="toast pointer-events-auto flex items-start gap-3 rounded-lg px-4 py-3 shadow-lg text-sm text-mtm-on-brand min-w-72 max-w-sm"
      [class.toast--success]="toast.type === 'success'"
      [class.toast--error]="toast.type === 'error'"
      role="alert"
    >
      <svg
        class="mt-0.5 shrink-0"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        @if (toast.type === 'success') {
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm3.78 5.22a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L4.22 8.28a.75.75 0 1 1 1.06-1.06L7 8.94l3.72-3.72a.75.75 0 0 1 1.06 0Z"
            fill="currentColor"
          />
        } @else {
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm0 1.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13ZM8 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4Zm0 7.5a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z"
            fill="currentColor"
          />
        }
      </svg>
      <span class="flex-1 leading-snug">{{ toast.message }}</span>
      <button
        type="button"
        class="shrink-0 mt-0.5 opacity-70 hover:opacity-100 transition-opacity focus:outline-none"
        (click)="notificationSvc.dismiss(toast.id)"
        aria-label="Dismiss notification"
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M1 1l10 10M11 1 1 11"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>
  }
</div>
